<template>
  <div class="m-card">
    <div class="m-card__header">
      <div class="title-c">{{ title }}</div>
    </div>
    <div class="m-card__main" v-if="variant === 'failed'">
      <button class="progress-state__action" :disabled="isRetrying" @click="$emit('retry')">
        {{ isRetrying ? 'Reintentando…' : 'Reintentar' }}
      </button>
    </div>
    <div class="m-card__footer" :class="{ orange: variant === 'failed' }">
      <div>{{ text }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressState',
  props: {
    variant: { type: String, required: true },
    title: { type: String, required: true },
    text: { type: String, required: true },
    isRetrying: { type: Boolean, default: false }
  }
}
</script>

<style lang="scss" scoped>
.progress-state__action {
  border: 0;
  border-radius: 8px;
  background: #27884d;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  padding: 8px 18px;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
}
</style>
